import styled from "styled-components";

export const TableTitle = styled("h4")`
    font-size: 20px;
    font-weight: 500;
    color: #454545;
    letter-spacing: 0.05em;
`

export default TableTitle;